import { ChevronLeftIcon, ChevronRightIcon, Row, useTheme } from "@commonlibs";
import clsx from "clsx";
import { useNavigation } from "react-day-picker";
import DatePickerYearSelect from "../DatePickerYearSelect/DatePickerYearSelect";
import { DatePickerArrowIcon, DatePickerCalendarHeaderRoot } from "./DatePickerCalendarHeader.styles";
import { DatePickerCalendarHeaderProps } from "./DatePickerCalendarHeader.types";
import useFormatDateTime from "ui/common/hooks/useFormatDateTime/useFormatDateTime";

function DatePickerCalendarHeader({ className, displayMonth, ...rest }: DatePickerCalendarHeaderProps) {
    const { goToMonth, nextMonth, previousMonth } = useNavigation();
    const formatDate = useFormatDateTime();
    const { spacing } = useTheme();

    return (
        <DatePickerCalendarHeaderRoot
            className={clsx("date-picker-calendar-header", className)}
            alignItems="center"
            justifyContent="space-between"
            {...rest}
        >
            <Row alignItems="center">
                <span>{formatDate(displayMonth, { month: "short", year: "numeric" })}</span>
                <DatePickerYearSelect />
            </Row>
            <Row gap={spacing["1"]}>
                {previousMonth && (
                    <DatePickerArrowIcon onClick={() => goToMonth(previousMonth)}>
                        <ChevronLeftIcon />
                    </DatePickerArrowIcon>
                )}
                {nextMonth && (
                    <DatePickerArrowIcon onClick={() => goToMonth(nextMonth)}>
                        <ChevronRightIcon />
                    </DatePickerArrowIcon>
                )}
            </Row>
        </DatePickerCalendarHeaderRoot>
    );
}

export default DatePickerCalendarHeader;
